var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "c-location-box__wrapper" },
    [
      _vm.isLoading ? _c("loading-spinner") : _vm._e(),
      _vm._v(" "),
      _c("div", { staticClass: "c-location-box" }, [
        _c("div", { staticClass: "c-location-box__content" }, [
          _c(
            "div",
            {
              directives: [
                {
                  name: "show",
                  rawName: "v-show",
                  value: !_vm.selectAddress,
                  expression: "!selectAddress"
                }
              ]
            },
            [
              _c("div", { staticClass: "c-form-input" }, [
                _c(
                  "label",
                  {
                    staticClass: "c-form-input__label",
                    attrs: { for: "customerAccountReference" }
                  },
                  [_vm._v(_vm._s(_vm.customerAccountReferenceLabel))]
                ),
                _vm._v(" "),
                _c("input", {
                  directives: [
                    {
                      name: "model",
                      rawName: "v-model.number",
                      value: _vm.customerAccountReference,
                      expression: "customerAccountReference",
                      modifiers: { number: true }
                    }
                  ],
                  staticClass: "c-form-input__control",
                  attrs: {
                    "aria-describedby": "customerAccountReferenceError",
                    type: "number",
                    name: "customerAccountReference",
                    id: "customerAccountReference"
                  },
                  domProps: { value: _vm.customerAccountReference },
                  on: {
                    keyup: function($event) {
                      if (
                        !$event.type.indexOf("key") &&
                        _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")
                      ) {
                        return null
                      }
                      $event.preventDefault()
                      return _vm.getLocation($event)
                    },
                    keypress: function($event) {
                      return _vm.isNumber($event)
                    },
                    input: function($event) {
                      if ($event.target.composing) {
                        return
                      }
                      _vm.customerAccountReference = _vm._n($event.target.value)
                    },
                    blur: function($event) {
                      return _vm.$forceUpdate()
                    }
                  }
                }),
                _vm._v(" "),
                _vm.searchError
                  ? _c(
                      "span",
                      {
                        staticClass: "c-form-input__validation-message",
                        attrs: { id: "customerAccountReferenceError" }
                      },
                      [_vm._v(_vm._s(_vm.customerLocationValidationError))]
                    )
                  : _vm._e()
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "c-form-input c-form-input--short" }, [
                _c("label", {
                  staticClass: "c-form-input__label",
                  attrs: { for: "postcode" },
                  domProps: { innerHTML: _vm._s(_vm.postcodeLabel) }
                }),
                _vm._v(" "),
                _c("input", {
                  directives: [
                    {
                      name: "model",
                      rawName: "v-model",
                      value: _vm.postcode,
                      expression: "postcode"
                    }
                  ],
                  staticClass: "c-form-input__control",
                  attrs: {
                    "aria-describedby": "postcodeError",
                    type: "text",
                    name: "postcode",
                    id: "postcode"
                  },
                  domProps: { value: _vm.postcode },
                  on: {
                    keyup: function($event) {
                      if (
                        !$event.type.indexOf("key") &&
                        _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")
                      ) {
                        return null
                      }
                      $event.preventDefault()
                      return _vm.getLocation($event)
                    },
                    input: function($event) {
                      if ($event.target.composing) {
                        return
                      }
                      _vm.postcode = $event.target.value
                    }
                  }
                }),
                _vm._v(" "),
                _vm.searchError
                  ? _c(
                      "span",
                      {
                        staticClass: "c-form-input__validation-message",
                        attrs: { id: "postcodeError" }
                      },
                      [_vm._v(_vm._s(_vm.customerLocationValidationError))]
                    )
                  : _vm._e()
              ]),
              _vm._v(" "),
              _vm.notFound
                ? _c("div", {
                    staticClass: "c-rap-rte",
                    attrs: { role: "alert" },
                    domProps: { innerHTML: _vm._s(_vm.locationNotFound) }
                  })
                : _vm._e(),
              _vm._v(" "),
              _vm.contactDetailsRequestError
                ? _c(
                    "div",
                    { staticClass: "c-rap-rte", attrs: { role: "alert" } },
                    [
                      _c("p", [
                        _vm._v(_vm._s(_vm.contactDetailsRequestErrorText))
                      ])
                    ]
                  )
                : _vm._e()
            ]
          ),
          _vm._v(" "),
          _c(
            "div",
            {
              directives: [
                {
                  name: "show",
                  rawName: "v-show",
                  value: _vm.selectAddress,
                  expression: "selectAddress"
                }
              ]
            },
            [
              _c("div", { staticClass: "c-rap-address" }, [
                _c(
                  "ul",
                  { staticClass: "c-rap-address__list" },
                  _vm._l(_vm.suggestedAddresses, function(suggestion, index) {
                    return _c(
                      "li",
                      {
                        key: suggestion.value,
                        staticClass: "c-rap-address__item"
                      },
                      [
                        _c("input", {
                          directives: [
                            {
                              name: "model",
                              rawName: "v-model",
                              value: _vm.address,
                              expression: "address"
                            }
                          ],
                          staticClass: "visually-hidden",
                          attrs: {
                            name: "address",
                            type: "radio",
                            id: _vm.addressId(index)
                          },
                          domProps: {
                            value: suggestion.value,
                            checked: _vm._q(_vm.address, suggestion.value)
                          },
                          on: {
                            change: [
                              function($event) {
                                _vm.address = suggestion.value
                              },
                              _vm.addressChange
                            ]
                          }
                        }),
                        _vm._v(" "),
                        _c(
                          "label",
                          {
                            staticClass: "c-rap-address__label",
                            attrs: { for: _vm.addressId(index) }
                          },
                          [_vm._v(_vm._s(suggestion.label))]
                        )
                      ]
                    )
                  }),
                  0
                ),
                _vm._v(" "),
                _vm.addressError
                  ? _c(
                      "span",
                      {
                        staticClass: "c-rap-address__validation-message",
                        attrs: { id: "postcodeError" }
                      },
                      [_vm._v("Address field is required")]
                    )
                  : _vm._e()
              ]),
              _vm._v(" "),
              _c("div", {
                staticClass: "c-rap-rte",
                attrs: { role: "alert" },
                domProps: { innerHTML: _vm._s(_vm.locationNotListed) }
              })
            ]
          )
        ]),
        _vm._v(" "),
        !_vm.locationValid
          ? _c("div", { staticClass: "c-location-box__extra" }, [
              _c("div", {
                ref: "rte",
                staticClass: "c-rap-rte",
                domProps: { innerHTML: _vm._s(_vm.locationNotValid) }
              })
            ])
          : _vm._e(),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "c-location-box__actions" },
          [
            !_vm.selectAddress
              ? [
                  _c(
                    "button",
                    {
                      staticClass:
                        "c-button c-button--brand c-button--text-center",
                      attrs: { type: "button", disabled: _vm.isLoading },
                      on: { click: _vm.backToWizard }
                    },
                    [
                      _vm._v(
                        "\n          " +
                          _vm._s(_vm.backButtonText) +
                          "\n        "
                      )
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "button",
                    {
                      staticClass:
                        "c-button c-button--brand c-button--text-center",
                      attrs: { type: "button", disabled: _vm.isLoading },
                      on: { click: _vm.getLocation }
                    },
                    [
                      _vm._v(
                        "\n          " +
                          _vm._s(_vm.relevantSearchButtonText) +
                          "\n        "
                      )
                    ]
                  )
                ]
              : _vm._e(),
            _vm._v(" "),
            _vm.selectAddress
              ? [
                  _c(
                    "button",
                    {
                      staticClass:
                        "c-button c-button--brand c-button--text-center",
                      attrs: { type: "button", disabled: _vm.isLoading },
                      on: { click: _vm.resetLocation }
                    },
                    [
                      _vm._v(
                        "\n          " +
                          _vm._s(_vm.backButtonText) +
                          "\n        "
                      )
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "button",
                    {
                      staticClass:
                        "c-button c-button--brand c-button--text-center",
                      attrs: { type: "button", disabled: _vm.isLoading },
                      on: { click: _vm.selectLocation }
                    },
                    [
                      _vm._v(
                        "\n          " +
                          _vm._s(_vm.relevantContinueButtonText) +
                          "\n        "
                      )
                    ]
                  )
                ]
              : _vm._e()
          ],
          2
        )
      ])
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-4978cd3a", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4978cd3a","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/components/consumer/report-a-problem/_vue/LocationBox.vue
// module id = 694
// module chunks = 0